module.exports = __webpack_public_path__ + "img/train-1.b80156fd.jpg";